// extracted by mini-css-extract-plugin
module.exports = {"tradeOptionsList":"styles_tradeOptionsList__NlkRz","optionTitle":"styles_optionTitle__hcbYs"};